import {cs}              from "../../react/chain-services";
import {fragments}       from "../../react/fragments";
import {GlobalMouseMove} from "../../react/global-mouse-move";
import {UseState}        from "../../react/use-state";

import {getELoc} from "./get-e-loc";

export const ObserveMousePos = ({next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => fragments(
        GlobalMouseMove({
            action: (e) => state.onChange(getELoc(e)),
        }),
        next(state.value),
    )
);
